import { React, useState, useRef } from 'react';
// import IntlMessages from '@iso/components/utility/intlMessages';
// import Checkbox, { CheckboxGroup } from '@iso/components/uielements/checkbox';
import Box from '@iso/components/utility/box';
import ContentHolder from '@iso/components/utility/contentHolder';
// import Button from '@iso/components/uielements/button';
import { Input, Spin, Form, Collapse } from 'antd';
import CreateTaskHeader from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskHeader/CreateTaskHeader';
import { useContext } from 'react';
import { AppContext } from '../../../context/ContextProvider';
import styled, { createGlobalStyle } from 'styled-components';
import Select from '../../Deployments/Deployment.styles';
import {
    SelectOption as Option,
} from '@iso/components/uielements/select';
import initialData from '../../../redux/scrumBoard/data';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { borderRadius } from '../../../library/helpers/style_utils';
import {
    PlusOutlined
} from '@ant-design/icons';
import plusIcon from '../../../assets/images/plusIcon.svg';
import { Link } from 'react-router-dom';
import CreateTaskFooter from '../../ScrumBoard/Task/TaskCreateOrUpdate/CreateTaskFooter/CreateTaskFooter';
import deleteIcon from '../../../assets/images/tagsDelete.svg';
import eyeIcon from '@iso/assets/images/icon/eye-icon.svg';
import eyeCloseIcon from '@iso/assets/images/icon/eye-close-icon.svg';
import { Switch } from 'antd';
import downIcon from '../../../assets/images/downArrow.svg';
import upIcon from '../../../assets/images/upArrow.svg';
import api from '../../../api';
import InputWithSuffix from '../../../components/uielements/input';
import CustomInfoTooltip from '../../Dashboard/CustomComponents/CustomInfoTooltip';
import { clusterHelpChecks } from '../clusterHelpChecks';
import { LoadingOutlined } from '@ant-design/icons';
import { BreadcrumbContext } from '../../../context/breadcrumbContext';
import { useDeploymentFeatures } from '../../Dashboard/CustomHooks/useDeploymentFeatures';

const ProdContentHold = styled.div`
  .isoBoxWrapper {
    height: auto;
    border: none;
    margin: 0;
  }
`;

var optionAzs = [];

let innerTitleStyle = {
    color: "#1f1f1f",
    fontFamily: "Poppins",
    fontType: "medium",
    fontWeight: "500",
    fontSize: "14px"
};

let innerSubtitleStyle = {
    fontSize: "12px",
    color: "#9b9b9b",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontType: "regular",
}

const inputStyle = {
    height: "44px"
}

// Amber callout shown under the Hostname for private imported clusters, where
// Atmosly can create the ingress but can't manage DNS on the user's behalf.
let dnsNoteStyle = {
    display: "block",
    marginTop: "8px",
    padding: "8px 12px",
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    fontWeight: '600',
    color: "#ad6800",
    lineHeight: "18px",
    wordWrap: "break-word",
    background: "#fffbe6",
    border: "1px solid #ffe58f",
    borderRadius: "6px",
}

const sectionHeaderStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    color: "#132f44",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13px",
    letterSpacing: "0.03em",
    textTransform: "uppercase",
    margin: "30px 0 14px",
}

// Renders a section label followed by a full-width rule so each group
// (Stack / Data sources / Access / Scheduling) reads as a clear divider.
const SectionHeader = ({ children }) => (
    <div style={sectionHeaderStyle}>
        <span style={{ whiteSpace: "nowrap" }}>{children}</span>
        <span style={{ flex: 1, height: "1px", background: "#e5e7eb" }} />
    </div>
)

// A Box whose right edge carries a control (status pill or Switch). The text
// column flexes — `minWidth: 0` lets the description wrap instead of forcing the
// row wider — while the control is pinned right with `flexShrink: 0`. This
// replaces the earlier absolutely-positioned control, which reserved no width
// and so let the wrapped description slide underneath it (the text overlap /
// overflow bug).
const ControlBox = ({ title, subtitle, control }) => (
    <Box>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "20px" }}>
            <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ ...innerTitleStyle, display: "flex", alignItems: "center", gap: "8px", marginBottom: "5px" }}>{title}</div>
                <div style={{ ...innerSubtitleStyle, lineHeight: "20px" }}>{subtitle}</div>
            </div>
            <div style={{ flexShrink: 0 }}>{control}</div>
        </div>
    </Box>
)

export default function PglStackDrawer({
    // handleSubmit,
    data,
    setData,
    values,
    submitCount,
    onClose,
    onCancel,
    onDelete,
    openDrawer,
    refresh,
    setRefresh,
    updateOnlyChangedAddons,
    onEditCancel,
    tabSelected,
    openAddOns,
    column_id,
    openConfigDrawer,
    isReInstall,
}) {

    const { openRightDrawer, setOpenRightDrawer, allClusters, setAllClusters, currentCluster, setCurrentCluster, isUpdate, updateCluster, setUpdateCluster, isOneClick, oneClickCluster, setOneClickCluster, clusterTabSelected, fetchingClusterPrerequisites, setFetchingClusterPrerequisites, overviewData } = useContext(AppContext);
    const { pageHeading } = useContext(BreadcrumbContext);
    const { toggleAlert } = useDeploymentFeatures();
    const navigate = useNavigate();

    const [grafanaStackData, setgrafanaStackData] = useState(isUpdate ? { ...updateCluster[clusterTabSelected].grafanaStack } : isOneClick ? { ...oneClickCluster[clusterTabSelected].grafanaStack } : { ...currentCluster[clusterTabSelected].grafanaStack });

    const [hostedZones, setHostedZones] = useState([]);
    const [refreshIntervalList, setRefreshIntervalList] = useState([]);
    const [objExpirationList, setObjExpirationList] = useState([]);
    const [validateDomainStatus, setValidateDomainStatus] = useState("");
    const [fetching, setFetching] = useState(false);
    const [fetchingHostedZones, setFetchingHostedZones] = useState(false);
    const [hostedZonesReady, setHostedZonesReady] = useState(false);
    const [hostedZoneMetaMap, setHostedZoneMetaMap] = useState({});
    const [form] = Form.useForm();
    const [toggleEyeIcon, setToggleEyeIcon] = useState(false);

    const selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
    // For a private imported cluster Atmosly creates the ingress but can't reach a
    // public DNS provider on the user's behalf, so the DNS record must be mapped by
    // hand. "Private" mirrors the Cluster API Access logic in ClusterInfo: no public
    // endpoint access ⇒ private. Show the note only for imported + private clusters.
    const clusterData = overviewData?.data?.cluster_data || {};
    const isPrivateImportedCluster = clusterData.provisioner === "imported" && clusterData.cloud_account_id == null;
    const [dnsMsg, setDnsMsg] = useState({
        error: false,
        msg: ""
    });

    const [error, setError] = useState({
        status: false,
        msg: ""
    });
    const [passwordValidationError, setPasswordValidationError] = useState("");
    const passwordValidationTimeoutRef = useRef(null);

    // Pre-fill the Prometheus/Grafana resource fields with sensible defaults so the
    // stack deploys even if the user never touches them. Only fills values that are
    // missing/blank, so any previously-saved custom values are preserved.
    useEffect(() => {
        const resourceDefaults = {
            promCpuRequest: "200m", promCpuLimit: "1200m",
            promMemRequest: "800Mi", promMemLimit: "4Gi",
            promStorage: "50Gi", promRetention: "30d",
            grafanaCpuRequest: "300m", grafanaCpuLimit: "1000m",
            grafanaMemRequest: "500Mi", grafanaMemLimit: "3Gi",
        };
        const missing = {};
        Object.keys(resourceDefaults).forEach((k) => {
            const v = grafanaStackData[k];
            if (v === undefined || v === null || v === "") missing[k] = resourceDefaults[k];
        });
        if (Object.keys(missing).length) {
            setgrafanaStackData((prev) => ({ ...prev, ...missing }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const isGrafanaDrawerOpen = openRightDrawer?.drawerType === "pgl_stack";
        const hasHostedZones = Object.keys(selectedCluster?.[clusterTabSelected]?.hostedZones || {}).length > 0;
        const isClusterCreating = ["creating"].includes(overviewData?.data?.cluster_data?.cluster_phase?.toLowerCase());

        if (!isGrafanaDrawerOpen || hasHostedZones || isClusterCreating || fetchingHostedZones) {
            return;
        }

        setFetchingHostedZones(true);
        api.get(`${process.env.REACT_APP_API_URI}/api/project_env/hosted_zones/`)
            .then((res) => {
                const response = res.data;
                if (!response.status) {
                    toggleAlert("error", "Error", "Something went wrong. Please try again.");
                    return;
                }

                const validData = Object.keys(response.data || {})
                    .filter((key) => key !== "_errors")
                    .reduce((acc, key) => {
                        acc[key] = response.data[key];
                        return acc;
                    }, {});

                const targetCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
                targetCluster.prod.hostedZones = validData;
                targetCluster["non-prod"].hostedZones = validData;
                targetCluster.existingVpc.hostedZones = validData;

                if (isUpdate) {
                    setUpdateCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }
                else if (isOneClick) {
                    setOneClickCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }
                else {
                    setCurrentCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }

                if (response.data?._errors && Object.keys(response.data._errors).length > 0) {
                    const errorMessages = Object.values(response.data._errors).join(', ');
                    toggleAlert("warning", "Warning", `Some hosted zones could not be fetched: ${errorMessages}`);
                }
            })
            .catch((err) => {
                console.log("Error in /project_env/hosted_zones/ api :", err);
                const targetCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;

                targetCluster.prod.grafanaStack.hostname = "";
                targetCluster.prod.hostedZones = "";
                targetCluster.prod.grafanaStack.appName = "";
                targetCluster.prod.grafanaStack.recordPrefix = "";

                targetCluster["non-prod"].grafanaStack.hostname = "";
                targetCluster["non-prod"].hostedZones = "";
                targetCluster["non-prod"].grafanaStack.appName = "";
                targetCluster["non-prod"].grafanaStack.recordPrefix = "";

                targetCluster.existingVpc.grafanaStack.hostname = "";
                targetCluster.existingVpc.hostedZones = "";
                targetCluster.existingVpc.grafanaStack.appName = "";
                targetCluster.existingVpc.grafanaStack.recordPrefix = "";

                if (isUpdate) {
                    setUpdateCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }
                else if (isOneClick) {
                    setOneClickCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }
                else {
                    setCurrentCluster({ ...targetCluster, prod: targetCluster.prod, "non-prod": targetCluster["non-prod"], existingVpc: targetCluster.existingVpc });
                }

                toggleAlert("error", "Error", "Something went wrong. Please try again.");
            })
            .finally(() => {
                setFetchingHostedZones(false);
            });
    }, [openRightDrawer?.drawerType, clusterTabSelected, overviewData?.data?.cluster_data?.cluster_phase, selectedCluster?.[clusterTabSelected]?.hostedZones, fetchingHostedZones]);

    useEffect(() => {
        console.log("isUpdate :", isUpdate);
        setFetching(true);
        //console.log("hostedZones from currentCluster :", currentCluster[clusterTabSelected].hostedZones);
        let arr = [];
        const zoneMetaMap = {};
        let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;

        selectedCluster[clusterTabSelected].hostedZones && Object.keys(selectedCluster[clusterTabSelected].hostedZones).map((val, id) => {
            selectedCluster[clusterTabSelected].hostedZones[val].hosted_zones.map((zone, idx) => {
                zoneMetaMap[zone] = {
                    zoneId: val,
                    dnsRecordType: selectedCluster[clusterTabSelected].hostedZones[val].type
                };
                arr.push(
                    // <Option key={idx} name="hostname" data-alias={val} data-type={currentCluster[clusterTabSelected].hostedZones[val].type} value={zone}>{zone}</Option>
                    <Option key={`${idx}-${id}`} name="hostname" data-alias={val} data-type={selectedCluster[clusterTabSelected].hostedZones[val].type} value={zone}>
                        <div key={`${idx}-a`} style={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
                            <span key={`${idx}-b`} title={zone} style={{ flex: "-1", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                {zone}
                            </span>
                        </div>
                    </Option>
                );
            })
        });
        setHostedZonesReady(arr.length > 0);
        setHostedZoneMetaMap(zoneMetaMap);

        if (arr.length > 0) {
            const availableZones = arr.map((item) => item.props.value);
            const activeHostname = grafanaStackData.hostname || grafanaStackData.default_zone;
            const isActiveZonePresent = !!activeHostname && availableZones.includes(activeHostname);
            const hostnameToSet = isActiveZonePresent ? activeHostname : availableZones[0];

            if (hostnameToSet) {
                const zoneMeta = zoneMetaMap[hostnameToSet];
                setgrafanaStackData((prev) => ({
                    ...prev,
                    hostname: hostnameToSet,
                    default_zone: hostnameToSet,
                    zoneId: zoneMeta?.zoneId || prev.zoneId,
                    dnsRecordType: zoneMeta?.dnsRecordType || prev.dnsRecordType
                }));
            }
        }

        // arr = arr.sort((a, b) => console.log("a.props :", a.props));
        // arr = arr.sort((a, b) => a.props.value.localeCompare(b.props.value));

        // Object Expiration Dropdown
        let objExpirationDropdown = [];
        ["90"].map((val, idx) => {
            objExpirationDropdown.push(
                <Option key={idx} name="objExpiration" value={val}>{val}</Option>
            );
        });

        setObjExpirationList(objExpirationDropdown);
        setHostedZones(arr);
        setFetching(false);
    }, [currentCluster[clusterTabSelected].hostedZones, updateCluster[clusterTabSelected].hostedZones, oneClickCluster[clusterTabSelected].hostedZones]);

    useEffect(() => {
        let grafanaData = selectedCluster[clusterTabSelected].selectedAddons.find(val => val.name === "grafana-stack");
        console.log("grafana bord: ", grafanaData);
        if (grafanaData?.borderColor) {
            form.validateFields();
        }
    }, []);
    
    useEffect(() => {
        if (!hostedZonesReady || !grafanaStackData.zoneId || !grafanaStackData.dnsRecordType || !grafanaStackData.hostname) {
            return;
        }

        let myTimeout = setTimeout(() => {
            if (grafanaStackData.recordPrefix && grafanaStackData.recordPrefix !== "") {
                let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
                let checkFor = column_id === "grafana-stack" ? "grafana-stack" : selectedCluster[clusterTabSelected].selectedAddons.find(val => val.name === "grafana-stack")?.name;
                dnsCheck(grafanaStackData.recordPrefix, grafanaStackData.hostname, grafanaStackData.zoneId, grafanaStackData.dnsRecordType, checkFor);
            }
        }, 2000);

        return () => clearTimeout(myTimeout);
    }, [hostedZonesReady, grafanaStackData.recordPrefix, grafanaStackData.hostname, grafanaStackData.zoneId, grafanaStackData.dnsRecordType]);

    useEffect(() => {
        if (passwordValidationTimeoutRef.current) {
            clearTimeout(passwordValidationTimeoutRef.current);
        }

        passwordValidationTimeoutRef.current = setTimeout(() => {
            if ((grafanaStackData.grafanaPassword || "").includes("$")) {
                const errMsg = "$ symbol is not supported in passwords.";
                setPasswordValidationError(errMsg);
                form.setFields([
                    {
                        name: "grafanaPassword",
                        errors: [errMsg]
                    }
                ]);
                return;
            }

            setPasswordValidationError("");
            form.setFields([
                {
                    name: "grafanaPassword",
                    errors: []
                }
            ]);
        }, 500);

        return () => {
            if (passwordValidationTimeoutRef.current) {
                clearTimeout(passwordValidationTimeoutRef.current);
            }
        };
    }, [grafanaStackData.grafanaPassword, form]);

    const handleSelectChange = (value, event) => {
        console.log("event :", event);
        console.log("value :", value);

        if (event?.name === "hostname") {
            const zoneMeta = hostedZoneMetaMap[value] || {};
            grafanaStackData.zoneId = event["data-alias"] || zoneMeta.zoneId;
            grafanaStackData.dnsRecordType = event["data-type"] || zoneMeta.dnsRecordType;
            grafanaStackData[event.name] = value;
            grafanaStackData.default_zone = value;

            setDnsMsg({
                error: false,
                msg: ""
            });
        }
        else {
            const zoneMeta = hostedZoneMetaMap[value] || {};
            grafanaStackData.hostname = value;
            grafanaStackData.default_zone = value;
            grafanaStackData.zoneId = zoneMeta.zoneId;
            grafanaStackData.dnsRecordType = zoneMeta.dnsRecordType;
        }

        console.log("grafanaStackData :", grafanaStackData);
        setgrafanaStackData({ ...grafanaStackData });
        setError({
            status: false,
            msg: ""
        });
    };

    const handelInputChange = (e) => {
        setgrafanaStackData({ ...grafanaStackData, [e.target.name]: e.target.value });
        if (e.target.name === "recordPrefix") {
            setDnsMsg({
                error: false,
                msg: ""
            });
        }
        setError({
            status: false,
            msg: ""
        });
    };

    const dnsCheck = (recordPrefix, zoneName, zoneId, dnsRecordType, checkFor) => {
        setValidateDomainStatus("validating");
        api.post('/api/cluster/check-dns/', [{
            "record_name": recordPrefix,
            "zone_id": zoneId,
            "dns_record_type": dnsRecordType,
            "zone_name": zoneName,
            "check_for": checkFor
        }]).then((res) => {
            let data = res.data;
            if (data.status) {
                let successMsg = "";
                if (typeof data.data === "string") {
                    successMsg = data.data;
                } else if (typeof data.data === "object" && data.data !== null) {
                    const firstVal = Object.values(data.data)[0];
                    successMsg = typeof firstVal === "string" ? firstVal : JSON.stringify(firstVal);
                }
                setDnsMsg({
                    error: false,
                    msg: successMsg || "DNS record can be created."
                });
                setValidateDomainStatus("success");
            }
            else {
                console.log("data.error_details :", data.error_details);
                // console.log("type of data.error_details :", typeof data.error_details);
                // console.log("data.error_details is object? :", typeof data.error_details === "object");
                setDnsMsg({
                    error: true,
                    msg: Array.isArray(data.error_details) 
                        ? Object.values(data.error_details[0])[0] 
                        : (typeof data.error_details === "object" && data.error_details !== null)
                            ? Object.values(data.error_details)[0] 
                            : "Something went wrong. Please try again."
                });
                setValidateDomainStatus("error");
            }
        }).catch((err) => {
            console.log("Error");
            setValidateDomainStatus("error");
        });
    }

    const handleCancel = (e) => {
        setOpenRightDrawer({
            drawerType: false,
            drawerProps: {
                grafanaStackData: "",
            },
        });

        // onClose();
    };

    const handleSaveDetails = async (e) => {
        try {
            if ((grafanaStackData.grafanaPassword || "").includes("$")) {
                const errMsg = "$ symbol is not supported in passwords.";
                setPasswordValidationError(errMsg);
                form.setFields([
                    {
                        name: "grafanaPassword",
                        errors: [errMsg]
                    }
                ]);
                return;
            }

            const values = await form.validateFields();
            console.log('Success:', values);
            console.log('grafanaStackData :', grafanaStackData);
            let selectedCluster = isUpdate ? updateCluster : isOneClick ? oneClickCluster : currentCluster;
            let updatedAddonData = {}

            selectedCluster[clusterTabSelected].grafanaStack = grafanaStackData;

            for (let i = 0; i < selectedCluster[clusterTabSelected].selectedAddons.length; i++) {
                if (selectedCluster[clusterTabSelected].selectedAddons[i].name === "grafana-stack") {
                    updatedAddonData = selectedCluster[clusterTabSelected].selectedAddons[i];

                    if (dnsMsg.error) {
                        selectedCluster[clusterTabSelected].selectedAddons[i] = {
                            ...selectedCluster[clusterTabSelected].selectedAddons[i],
                            message: dnsMsg.msg,
                            borderColor: "red"
                        };
                        break;
                    }
                    else {
                        selectedCluster[clusterTabSelected].selectedAddons[i] = {
                            ...selectedCluster[clusterTabSelected].selectedAddons[i],
                            message: "",
                            borderColor: "#f5f5f5"
                        };
                        break;
                    }
                }
            }

            if (isUpdate) {
                setUpdateCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('updateCluster', JSON.stringify(({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                })));
            }
            else if (isOneClick) {
                setOneClickCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('oneClickCluster', JSON.stringify({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                }));
            }
            else {
                setCurrentCluster({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                });
                localStorage.setItem('Cluster', JSON.stringify({
                    ...selectedCluster,
                    clusterTabSelected: selectedCluster[clusterTabSelected]
                }));
            }

            console.log("updatedAddonData :", updatedAddonData);
            if(!isUpdate){
                setRefresh(refresh => !refresh);
            }
            else if(isUpdate && updatedAddonData?.selected){
                !openConfigDrawer && updateOnlyChangedAddons(updatedAddonData);
                openConfigDrawer && openConfigDrawer();
            }

            !openConfigDrawer && setOpenRightDrawer({
                drawerType: false,
                drawerProps: {
                    grafanaStackData: "",
                },
            });
        }
        catch (err) {
            console.log("Error :", err);
        }
    };

    const selectHostedZones = () => {

    }

    //   const filterClusterLogOption = (input, option) => (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());

    //   const filterVPCLogOption = (input, option) => (option?.value.toLowerCase() ?? '').includes(input.toLowerCase());


    return (
        <ProdContentHold>
            <CreateTaskHeader
                buttonContent="grafana-stack"
                data={grafanaStackData}
                // values={{editing: true}}
                onCancel={() => {
                    setOpenRightDrawer({
                        drawerType: false,
                        drawerProps: {
                            grafanaStackData: "",
                        },
                    });
                    // onClose();
                }}
                onDelete={onDelete}
                onEditCancel={() => {
                    setOpenRightDrawer({
                        drawerType: false,
                        drawerProps: {
                            grafanaStackData: "",
                        },
                    });
                    // onClose();
                }}
            />

            <Form
                form={form}
                initialValues={{ ...grafanaStackData }}
                preserve={false}
                name="dynamic_rule"
                style={{ padding: "23px" }}
                // disabled={isUpdate}
            >
                <Box
                    title={"Appname*"}
                    subtitle={"Enter the name of the stack."}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                    style={{ marginTop: "80px" }}
                >
                    <ContentHolder>
                        <Form.Item
                            name="appName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please provide App Name.',
                                },
                                {
                                    // Custom validator for special characters
                                    validator: (_, value) => {
                                        const specialCharPattern = /^([a-z0-9]+-*)+$/; // This regex allows only letters, numbers, and spaces
                                        if (!value || specialCharPattern.test(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('App name should start with alphanumeric char and can contain numbers, lowercase letters and hyphens only.'));
                                    }
                                },
                                {
                                    // Custom validator for special characters
                                    validator: (_, value) => {
                                        if (value && value.length <= 15) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('App name should not contain more than 15 characters.'));
                                    }
                                },
                            ]}
                        >
                            <Input
                                name="appName"
                                value={grafanaStackData.appName}
                                style={{ ...inputStyle }}
                                onChange={handelInputChange}
                                placeholder="Name"
                            />
                        </Form.Item>
                    </ContentHolder>
                </Box>

                <SectionHeader>Stack</SectionHeader>
                <ControlBox
                    title="Prometheus"
                    subtitle="Always installed — the core metrics engine (Prometheus + kube-state-metrics + recording rules) that powers cost optimization and right-sizing."
                    control={
                        <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap", fontSize: "11.5px", fontWeight: 700, color: "#16A34A", background: "#DCFCE7", border: "1px solid rgba(22,163,74,0.3)", borderRadius: "999px", padding: "4px 12px" }}>Always installed</span>
                    }
                />

                <ControlBox
                    title="Grafana"
                    subtitle="Toggle on to install Grafana dashboards — this also brings Alertmanager & Node-Exporter and needs the Hostname + Grafana credentials below. Leave off for a lightweight Prometheus-only cost-optimization collector."
                    control={
                        <Switch
                            style={(grafanaStackData.grafanaEnabled !== false) ? { backgroundColor: "#132f44" } : {}}
                            checked={grafanaStackData.grafanaEnabled !== false}
                            onChange={(checked) => {
                                // Loki is a Grafana log datasource — turning Grafana off
                                // forces Loki off too (no viewer without Grafana).
                                setgrafanaStackData({ ...grafanaStackData, grafanaEnabled: checked, ...(checked ? {} : { loki: false }) });
                                setError({ status: false, msg: "" });
                            }}
                        />
                    }
                />

                {(grafanaStackData.grafanaEnabled !== false) && (<>
                <SectionHeader>Access</SectionHeader>
                <Box
                    title={<div style={{ display: "flex", justifyContent: "space-between" }}>
                        <p>Hostname* {/*<Tooltip title="Can be increased but not decreased"><InfoCircleFilled style={{ marginLeft: "10px" }} /></Tooltip>*/}</p>
                        <CustomInfoTooltip title={clusterHelpChecks.pglAddon.hostName} placement={"bottomLeft"} />
                    </div>} subtitle={"Enter the hostname for the stack"}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <Form.Item
                            name="recordPrefix"
                            validateStatus={validateDomainStatus}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please provide hostname prefix.',
                                },
                                {
                                    // Custom validator for special characters
                                    validator: (_, value) => {
                                        const specialCharPattern = /^([a-z0-9]+\.*-*)+$/; // This regex allows only letters, numbers, and spaces
                                        console.log("currentCluster[clusterTabSelected].k8sDashboard.recordPrefix :", currentCluster[clusterTabSelected].k8sDashboard.recordPrefix);
                                        console.log("value :", value);
                                        if (value === currentCluster[clusterTabSelected].k8sDashboard.recordPrefix) {
                                            return Promise.reject(new Error('Hostname should not be same as kubernetes-dashboard hostname.'));
                                        }
                                        else if (!value || specialCharPattern.test(value)) {
                                            return Promise.resolve();
                                        }

                                        return Promise.reject(new Error('Hostname should start with alphanumeric char and can contain numbers, lowercase letters, hyphens or full stops.'));
                                    }
                                }
                            ]}
                        >
                            <InputWithSuffix
                                name="recordPrefix"
                                className='inputAddonAfter'
                                value={grafanaStackData.recordPrefix}
                                // styles={{...inputStyle}}
                                style={{ height: "44px !important", zIndex: 1 }}
                                onChange={handelInputChange}
                                placeholder="hostname"
                                suffix={validateDomainStatus === "validating" ? <LoadingOutlined /> : <></>}
                                addonAfter={
                                    <Select
                                        value={grafanaStackData.hostname || grafanaStackData.default_zone}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                        onChange={handleSelectChange}
                                        border={0}
                                        className="cusIntSelectDrop"
                                        style={{ padding: "0", borderRadius: "6px !important", zIndex: 1 }}
                                    >
                                        {fetching
                                            ?
                                            <Option>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40px" }}>
                                                    <Spin size="small" />
                                                </div>
                                            </Option>
                                            :
                                            hostedZones
                                        }
                                    </Select>
                                }
                            />
                        </Form.Item>
                        {dnsMsg.msg && <p style={{ color: dnsMsg.error ? "red" : "green", marginTop: "6px", marginBottom: 0 }}>{dnsMsg.msg}</p>}
                        {isPrivateImportedCluster && (
                            <span style={dnsNoteStyle}>
                                An ingress will be created for this hostname, but since this is a private cluster the DNS record must be mapped to it manually.
                            </span>
                        )}
                    </ContentHolder>
                </Box>

                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Grafana User* {/*<Tooltip title="Can be increased but not decreased"><InfoCircleFilled style={{ marginLeft: "10px" }} /></Tooltip>*/}</p>
                        <CustomInfoTooltip title={clusterHelpChecks.pglAddon.dashboardRefreshInterval} placement={"bottomLeft"} style={{ marginLeft: "10px" }} />
                    </div>} subtitle={"Specify grafana user"}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <Form.Item name="grafanaUser" rules={[
                            {
                                required: true,
                                message: "Please enter grafana user."
                            }
                        ]}>
                        <Input
                            name="grafanaUser"
                            value={grafanaStackData.grafanaUser}
                            style={{ ...inputStyle }}
                            onChange={handelInputChange}
                            placeholder="Grafana User"
                        />
                        </Form.Item>
                    </ContentHolder>
                </Box>

                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Grafana Password* {/*<Tooltip title="Can be increased but not decreased"><InfoCircleFilled style={{ marginLeft: "10px" }} /></Tooltip>*/}</p>
                        <CustomInfoTooltip title={clusterHelpChecks.pglAddon.dashboardRefreshInterval} placement={"bottomLeft"} style={{ marginLeft: "10px" }} />
                    </div>} subtitle={"Specify grafana password"}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <Form.Item
                            name="grafanaPassword"
                            validateStatus={passwordValidationError ? "error" : ""}
                            help={passwordValidationError || undefined}
                            rules={[
                            {
                                required: true,
                                message: "Please enter grafana password."
                            },
                            {
                                validator: (_, value) => {
                                    if ((value || "").includes("$")) {
                                        return Promise.reject(new Error("$ symbol is not supported in passwords."));
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}>
                        <Input
                            name="grafanaPassword"
                            value={grafanaStackData.grafanaPassword}
                            type={toggleEyeIcon ? "text" : "password"}
                            style={{ ...inputStyle }}
                            onChange={handelInputChange}
                            placeholder="Grafana Password"
                            suffix={<img src={toggleEyeIcon ? eyeIcon : eyeCloseIcon} alt="eye" style={{ cursor: "pointer" }} onClick={() => { setToggleEyeIcon(!toggleEyeIcon) }} />}
                        />
                        </Form.Item>
                    </ContentHolder>
                </Box>

                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Dashboard Refresh Interval* {/*<Tooltip title="Can be increased but not decreased"><InfoCircleFilled style={{ marginLeft: "10px" }} /></Tooltip>*/}</p>
                        <CustomInfoTooltip title={clusterHelpChecks.pglAddon.dashboardRefreshInterval} placement={"bottomLeft"} style={{ marginLeft: "10px" }} />
                    </div>} subtitle={"Specify the interval for dashboard refresh in seconds"}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <Input
                            name="refreshInterval"
                            value={grafanaStackData.refreshInterval}
                            style={{ ...inputStyle, cursor: "not-allowed" }}
                            onChange={handelInputChange}
                            placeholder="Name"
                            disabled={true}
                        />
                    </ContentHolder>
                </Box>

                <SectionHeader>Data sources</SectionHeader>
                <ControlBox
                    title="Loki"
                    subtitle="Toggle on to enable Loki log aggregation. Requires Grafana — Loki is surfaced as a Grafana datasource, so it is not installed in the Prometheus-only collector."
                    control={
                        <Switch
                            disabled={grafanaStackData.grafanaEnabled === false}
                            style={(grafanaStackData.grafanaEnabled !== false && grafanaStackData.loki) ? { backgroundColor: "#132f44" } : {}}
                            checked={grafanaStackData.grafanaEnabled !== false && !!grafanaStackData.loki}
                            onChange={(checked) => {
                                setgrafanaStackData({ ...grafanaStackData, loki: checked });
                                setError({
                                    status: false,
                                    msg: ""
                                });
                            }}
                        />
                    }
                />

                <ControlBox
                    title={<>CloudWatch collector <CustomInfoTooltip title={clusterHelpChecks.pglAddon.cloudWatchCollector} placement={"bottomLeft"} /></>}
                    subtitle="Toggle on to enable the CloudWatch collector for monitoring."
                    control={
                        <Switch style={grafanaStackData.cloudWatchCollector ? { backgroundColor: "#132f44" } : {}} checked={grafanaStackData.cloudWatchCollector} onChange={(checked) => {
                            setgrafanaStackData({ ...grafanaStackData, cloudWatchCollector: checked });
                            setError({
                                status: false,
                                msg: ""
                            });
                        }} />
                    }
                />

                </>)}

                <SectionHeader>Scheduling</SectionHeader>
                {/* Node placement — applies to the WHOLE stack (Prometheus + Grafana + Loki),
                    so it's shown regardless of the Grafana toggle. Single key=value label. */}
                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Node selector <span style={{ fontWeight: 400, color: "#888" }}>(optional)</span></p>
                    </div>}
                    subtitle={"Schedule the monitoring stack onto nodes carrying this label (nodeAffinity). Leave empty to use the default placement."}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder style={{ display: "flex", gap: "12px" }}>
                        <Input
                            name="nodeSelectorKey"
                            value={grafanaStackData.nodeSelectorKey || ""}
                            style={{ ...inputStyle }}
                            onChange={handelInputChange}
                            placeholder="Label key (e.g. workload)"
                        />
                        <Input
                            name="nodeSelectorValue"
                            value={grafanaStackData.nodeSelectorValue || ""}
                            style={{ ...inputStyle }}
                            onChange={handelInputChange}
                            placeholder="Label value (e.g. monitoring)"
                        />
                    </ContentHolder>
                </Box>

                <Collapse
                    ghost
                    style={{ marginTop: "16px" }}
                    items={[{
                        key: "resources",
                        label: <span style={{ ...innerTitleStyle }}>Advanced · resource sizing</span>,
                        children: (<>
                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Prometheus Resources</p>
                    </div>}
                    subtitle={"Requests / limits, persistent storage and retention for Prometheus. Leave a field blank to use its default (CPU 200m / 1200m, Memory 800Mi / 4Gi, Storage 50Gi, Retention 30d)."}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                            {[
                                { name: "promCpuRequest", label: "CPU Request", ph: "200m" },
                                { name: "promCpuLimit", label: "CPU Limit", ph: "1200m" },
                                { name: "promMemRequest", label: "Memory Request", ph: "800Mi" },
                                { name: "promMemLimit", label: "Memory Limit", ph: "4Gi" },
                                { name: "promStorage", label: "Storage Size", ph: "50Gi" },
                                { name: "promRetention", label: "Retention", ph: "30d" },
                            ].map((f) => (
                                <div key={f.name} style={{ flex: "1 1 45%", minWidth: "140px" }}>
                                    <p style={{ ...innerSubtitleStyle, marginBottom: "4px" }}>{f.label}</p>
                                    <Input
                                        name={f.name}
                                        value={grafanaStackData[f.name] || ""}
                                        style={{ ...inputStyle }}
                                        onChange={handelInputChange}
                                        placeholder={f.ph}
                                    />
                                </div>
                            ))}
                        </div>
                    </ContentHolder>
                </Box>
                    {(grafanaStackData.grafanaEnabled !== false) && (<>
                <Box
                    title={<div style={{ display: "flex" }}>
                        <p>Grafana Resources</p>
                    </div>}
                    subtitle={"Requests / limits for Grafana. Leave a field blank to use its default (CPU 300m / 1000m, Memory 500Mi / 3Gi)."}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
                            {[
                                { name: "grafanaCpuRequest", label: "CPU Request", ph: "300m" },
                                { name: "grafanaCpuLimit", label: "CPU Limit", ph: "1000m" },
                                { name: "grafanaMemRequest", label: "Memory Request", ph: "500Mi" },
                                { name: "grafanaMemLimit", label: "Memory Limit", ph: "3Gi" },
                            ].map((f) => (
                                <div key={f.name} style={{ flex: "1 1 45%", minWidth: "140px" }}>
                                    <p style={{ ...innerSubtitleStyle, marginBottom: "4px" }}>{f.label}</p>
                                    <Input
                                        name={f.name}
                                        value={grafanaStackData[f.name] || ""}
                                        style={{ ...inputStyle }}
                                        onChange={handelInputChange}
                                        placeholder={f.ph}
                                    />
                                </div>
                            ))}
                        </div>
                    </ContentHolder>
                </Box>
                    </>)}
                        </>),
                    }]}
                />

                {/* <Box
                    title={<div style={{ display: "flex", justifyContent: "space-between" }}>
                        <p>Object Expiration*</p>
                        <CustomInfoTooltip title={clusterHelpChecks.pglAddon.objectExpiration} placement={"bottomLeft"} />
                    </div>} subtitle={"Select the number of days after which S3 objects should expire."}
                    titleStyle={innerTitleStyle}
                    subTitleStyle={innerSubtitleStyle}
                >
                    <ContentHolder>
                        <Select
                            defaultValue={grafanaStackData.objExpiration}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                            onChange={handleSelectChange}
                            style={{ width: "100%" }}
                        >
                            {objExpirationList}
                        </Select>
                    </ContentHolder>
                </Box> */}

                <Box style={{ height: "150px" }}>
                    <Box>
                    </Box>
                </Box>
            </Form>
            <CreateTaskFooter buttonContent={"Grafana Stack"} disabled={!overviewData?.permissions?.includes("update") && pageHeading?.title !== "Add Addons"} givenButtonFunction1={handleSaveDetails} givenButtonFunction2={handleCancel} openDrawer={openDrawer} onUpdate={openConfigDrawer ? true : false} isReInstall={isReInstall} />
        </ProdContentHold>
    );
};
